import { combineReducers } from 'redux';
import * as actions from '../actions/ActionTypes';
import WordingService from '../services/WordingService';

const initialState = {
  images: [],
  indications: [],
  status: {
    valid: true,
    errorMessage: null,
  },
  selectedImages: [],
  isReady: false,
  isFetching: false,
};

/**
 * Array of images properties
 * @param state
 * @param action
 * @return {*}
 */
const images = (state = initialState.images, action) => {
  switch (action.type) {
    case actions.CREATE_CAPTCHA_SUCCESS:
      return action.payload.images;
    default:
      return state;
  }
};

/**
 * Array of user indications
 * @param state
 * @param action
 * @return {*}
 */
const indications = (state = initialState.indications, action) => {
  switch (action.type) {
    case actions.CREATE_CAPTCHA_SUCCESS:
      return action.payload.indications;
    default:
      return state;
  }
};

/**
 * Object captcha error
 * @param state
 * @param action
 * @return {*}
 */
const status = (state = initialState.status, action) => {
  switch (action.type) {
    case actions.NOT_FINISHED_CAPTCHA:
      return {
        valid: false,
        errorMessage: WordingService.getWording('errorMessage', 'unfinishedCaptcha'),
      };
    case actions.INVALID_CAPTCHA:
      return {
        valid: false,
        errorMessage: WordingService.getWording('errorMessage', 'invalidCaptcha'),
      };
    case actions.ADD_IMAGE_CAPTCHA:
      if (!state.valid) {
        return {
          valid: true,
          errorMessage: null,
        };
      }
      return state;
    default:
      return state;
  }
};

/**
 * Array of selected images
 * @param state
 * @param action
 * @return {*}
 */
const selectedImages = (state = initialState.selectedImages, action) => {
  switch (action.type) {
    case actions.ADD_IMAGE_CAPTCHA:
      if (state.length < 6) {
        return [
          ...state,
          action.payload.image,
        ];
      }
      return state;
    case actions.REMOVE_LAST_IMAGE_CAPTCHA: {
      const selectedImagesCopy = state.slice();
      selectedImagesCopy.pop();
      return selectedImagesCopy;
    }
    case actions.CLEAR_CAPTCHA:
      return initialState.selectedImages;
    default:
      return state;
  }
};

/**
 * Boolean indicate when captcha is loaded
 * @param state
 * @param action
 * @return {boolean}
 */
const isReady = (state = initialState.isReady, action) => {
  switch (action.type) {
    case actions.CREATE_CAPTCHA_SUCCESS:
      return true;
    default:
      return state;
  }
};

/**
 * Boolean indicate while captcha is fetching
 * @param state
 * @param action
 * @return {boolean}
 */
const isFetching = (state = initialState.isFetching, action) => {
  switch (action.type) {
    case actions.CREATE_CAPTCHA:
      return true;
    case actions.CREATE_CAPTCHA_SUCCESS:
    case actions.CREATE_CAPTCHA_FAILURE:
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  images,
  indications,
  status,
  selectedImages,
  isReady,
  isFetching,
});
